export enum TractorType {
    TwoAxleTractor = 0,
    ThreeAxleTractor = 1,
  }